<template>
    <div class="position-box IEO">
        <div class="head">
            <img class="back" v-if="theme" src="@/assets/theme/icon_back.png" @click="back" alt="">
            <img class="back" v-else src="@/assets/icon_back.png" @click="back" alt="">
            <div class="title">{{$t('ieo.ieo')}}</div>
        </div>
        <div class="cotainer help">
          <div class="ieo-wrap">
            <div class="ieo-head">
              <!-- <img class="icon1" v-if="theme" src="@/assets/trend_tabulate.png" @click="showLeft" alt="">
              <img class="icon1" v-else src="@/assets/new3/gengduo.png" @click="showLeft" alt=""> -->
              <!-- <div class="ieo-mid">
                <img class="img" :src="item.icon" alt="">
                <div class="text">{{item.currency}}</div>
              </div> -->
              <!-- <img class="icon2" @click="jump" src="@/assets/new3/gupiao.png" alt=""> -->
              <!-- <img class="icon2" v-if="theme" src="@/assets/theme/jilu.png" @click="jump" alt="">
              <img class="icon2" v-else src="@/assets/dingdan.png" @click="jump" alt=""> -->
            </div>
            <div class="ieo-item">
              <div class="item-lt">
                <div class="t1">{{$t('ieo.csjg')}}</div>
                <div class="t2">{{item.start_price}} {{item.currency}}</div>
              </div>
              <div class="img-box"><img class="img" :src="item.icon" alt=""></div>
              <div class="item-rt">
                <div class="t1">{{$t('xbsg.fxl')}}</div>
                <div class="t2">{{item.make_amount}}</div>
              </div>
            </div>
            <div class="time-box" v-show="item.yxq_end">{{$t('ieo.jzrq')}} <span class="time">{{item.yxq_end | timesChange}}</span></div>
            <!-- <div class="time-box">{{$t('ieo.yjs')}}</div> -->
          </div>
          <ul class="ul-box">
            <li class="ul-li" @click="jump2(item.currency)">
              <div class="title">
                <div>{{item.currency}}/USDT-{{$t('ieo.sjd')}}</div>
                <!-- <div class="t2 active" v-if="item.status == 0">{{$t('xbsg.shz')}}</div>
                <div class="t2" v-else-if="item.status == 1">{{$t('xbsg.ytg')}}</div>
                <div class="t2" v-else>{{$t('xbsg.wtg')}}</div> -->
              </div>
              <div class="item-box">
                <div class="item">
                  <div class="t1">{{$t('ieo.zsl')}}</div>
                  <div class="t2">{{totalAmount}}</div>
                </div>
                <div class="item item2">
                  <div class="t1">{{$t('ieo.zyk')}}</div>
                  <div class="t2 money">{{totalProfitLoss | toFixed3}}</div>
                </div>
              </div>
              <img class="arrow" v-if="theme" src="@/assets/theme/jiantou_white.png" alt="">
              <img class="arrow" v-else src="@/assets/user/jiantou.png" alt="">
            </li>
            <!-- <li class="ul-li">
              <div class="title">ZFB/USDT-市价单</div>
              <div class="item-box">
                <div class="item-lt">
                  <div class="item">
                    <div class="t1">总数量</div>
                    <div class="t2">101252235.0000</div>
                    <div class="t1">总盈亏</div>
                    <div class="t2 money">+$35532210.0000</div>
                  </div>
                </div>
                <div class="item-rt">
                  <div class="item">
                    <div class="t1">价格</div>
                    <div class="t2">202.20</div>
                    <div class="t1">时间</div>
                    <div class="t2">2024-12-6</div>
                  </div>
                </div>
              </div>
            </li> -->
          </ul>
          <!-- 暂无数据 -->
          <div class="null-box" v-show="hasData">
            <img class="icon" v-if="!theme" src="@/assets/Null.png" alt="">
            <img class="icon" v-else src="@/assets/theme/wushuju.png" alt="">
            <p class="text">{{$t('zwsj.title')}}</p>
          </div>
          <div class="buy-box" v-show="!isEnd" @click="goBuy(item.id)">{{$t('ieo.ljmr')}}</div>
           <div class="buy-box" v-show="isEnd">{{$t('ieo.yjs')}}</div>
          <!-- 左侧弹窗 -->
          <div class="alert-wrap" v-show="isSelect" @click.stop="close2">
            <div class="alert-box">
              <div class="alert-item" v-for="(item, index) in currencyList" :key="index" @click.stop="selectBz(item)">
                <template v-if="lang == 'ar'">
                  <img class="arrow" v-if="theme" src="@/assets/theme/icon_back.png" alt="">
                  <img class="arrow" v-else src="@/assets/alb/icon_back.png" alt="">
                  <div class="text" style="text-align: right">{{item.currency}}</div>
                  <img class="icon" :src="item.icon" alt="">
                </template>
                <template v-else>
                  <img class="icon" :src="item.icon" alt="">
                  <div class="text">{{item.currency}}</div>
                  <img class="arrow" v-if="theme" src="@/assets/theme/jiantou_white.png" alt="">
                  <img class="arrow" v-else src="@/assets/arrow_right.png" alt="">
                </template>
              </div>
              <!-- <div class="alert-item" @click="selectBz">
                <img class="icon" src="@/assets/new3/gengduo.png" alt="">
                <div class="text">ZFB</div>
                <img class="arrow" src="@/assets/arrow_right.png" alt="">
              </div> -->
              <!-- 暂无数据 -->
              <div class="null-box" v-show="hasData">
                <img class="icon" v-if="!theme" src="@/assets/Null.png" alt="">
                <img class="icon" v-else src="@/assets/theme/wushuju.png" alt="">
                <p class="text">{{$t('zwsj.title')}}</p>
              </div>
            </div>
          </div>
          <!-- 购买弹窗 -->
          <div class="alert-buy-wrap" v-show="isBuy">
            <div class="alert-buy-box">
              <ul class="type-box">
                <li class="type">{{$t('langNew.lx')}}</li>
                <li class="text">{{$t('ieo.sjd')}}</li>
              </ul>
              <div class="alert-tips">{{$t('bbjy.ky')}}</div>
              <div class="alert-text">{{useBalance}} USDT</div>
              <div class="alert-tips">{{$t('bbjy.km')}} </div>
              <div class="alert-text">{{kyMount}} {{item2.currency}}</div>
              <div class="alert-tips alert-tips2">{{$t('bbjy.sl')}} </div>
              <div class="input-box">
                <input class="input number" type="number" v-model="amount" @keyup="keyMoney()" :placeholder="$t('tipsNew.zdsl') + ' ' + item.min_amount">
                <div class="dw">{{item2.currency}}</div>
              </div>
              <div class="btn-box">
                <div class="btn btn-cancle" @click="close">{{$t('kjmb.qx')}}</div>
                <div class="btn btn-buy" @click="buy">{{$t('bbjy.mr')}}</div>
              </div>
            </div>
          </div>
        </div>
    </div>
</template>

<script>
import navBar from '@/components/NavBar.vue'
let that = this;
export default {
    name: 'IEOPurchase',
    data () {
      return {
        theme: false,
        token: '',
        id: '',
        list: [],
        currencyList: [],
        icon: '',
        item: {},
        item2: {},
        amount_rate: '',
        amount: '',
        isNoData: false,
        isNoData2: false,
        isSelect: false,
        hasData: false,
        theme: false,
        isBuy: false,
        tabIdx: 0,
        isEnd: true,
        endTimes: 0,
        zlEndTimes: 0,
        useBalance: '',
        kyMount: 0,
        totalProfitLoss: 0,
        totalAmount: 0,
        curPrice: 0,
        curDataLength: 10,
        curDataLength2: 10,
        isGoTOP: false,
        page: 1,
        page2: 1,
        lang: 'en',
        currency: '',
        timestamp: 0,
        timer: null,
        timer2: null,
        count: 1
      }
    },
    beforeCreate(){
        that = this;
    },
    created(){
      this.theme = JSON.parse(localStorage.getItem('theme'));
      this.token = localStorage.getItem('token') || '';
      this.lang = localStorage.getItem('language') || 'en';
    },
    mounted() {
      // this.getMyNewcoins();
      this.getNewcoinsList();
      this.getAsset();
      this.timer2 = setInterval(()=>{
        this.getWeiTuo();
      },5000)
    },
    methods: {
      back(){
        this.$router.push('/index')
      },
      jump(){
        this.$router.push('/IEORecords?currency=' + this.item.currency)
      },
      jump2(currency){
        this.$router.push('/IEORecords?currency=' + currency)
      },
      close(){
        this.isBuy = false;
      },
      close2(){
        this.isSelect = false;
      },
      goBuy(id){
        this.isBuy = true;
        this.getNewcoinsDetail(id);
      },
      showLeft(){
        this.isSelect = true;
      },
      selectBz(item){
        this.isSelect = false;
        this.item = item;
        this.amount_rate = item.amount_rate;
        this.endTimes = parseInt(item.yxq_end);
        this.beginTimer();
      },
      selectBz2(item,idx){
        this.tabIdx = idx;
        this.item = item;
        this.amount_rate = item.amount_rate;
        this.endTimes = parseInt(item.yxq_end);
        this.beginTimer();
      },
      initWebSocket(){ //初始化weosocket
          const wsuri = this.socket_url;
          this.websock = new WebSocket(wsuri);
          this.websock.onmessage = this.websocketonmessage;
          this.websock.onopen = this.websocketonopen;
          this.websock.onerror = this.websocketonerror;
          this.websock.onclose = this.websocketclose;
      },
      websocketonopen(){ //连接建立之后执行send方法发送数据
      },
      websocketonerror(){//连接建立失败重连
          this.initWebSocket();
      },
      websocketonmessage(e){ //数据接收
        let msg = JSON.parse(e.data).content;
        if(JSON.parse(e.data).action == "marketprice"){
          this.curPrice = msg[this.currency].now_price || this.item.start_price;
        }
      },
      websocketsend(Data){//数据发送
          this.websock.send(Data);
      },
      websocketclose(e){  //关闭
          // console.log('断开连接',e);
      },
      getWeiTuo(){
        let that = this;
        let params = {
          currency: that.item.currency,
          page: that.page,
          mark: 1,
          type: 1,
          wt: 12,
        }
        this.$ajax.get('/web/getWeiTuo',{params}).then((res) => {
            let resData = res.data.data.list;
            if(resData.length > 0){
              this.list = resData;
              var sumValue = resData.reduce(function(sum,resData){ //sum2 前两个数的和
                return sum + parseFloat(resData.amount);
              },0)  //第一次初始化时用0 + 数组中的第一项
              var sumValue2 = resData.reduce(function(sum,resData){ //sum2 前两个数的和
                return sum + parseFloat(resData.profit_loss);
              },0)  //第一次初始化时用0 + 数组中的第一项
              this.totalAmount = sumValue;
              this.totalProfitLoss = sumValue2;
              this.curDataLength = resData.length;
            }else{
              this.curDataLength = resData.length;
            }
            if(this.list.length > 0){
                this.isNoData = false;
            }else{
                this.isNoData = true;
            }
        }).catch(function(err){
            console.log(err)
        })
      },
      getAsset(){
        let params = {
          type: 1,
          currency: 'USDT',
        }
        this.$ajax.get('/web/getInfo',{params}).then((res) => {
          if(res.data.code == 1000){
            this.$router.push('/login')
          }else{
            let resData = res.data.data;
            this.useBalance =  (Number(resData.wallet.usdt)).toFixed(4);
          }
        }).catch(function(err){
            console.log(err)
        })
      },
      getNewcoinsDetail(id){
        let params = {
            id: id
        }
        this.$ajax.get('/web/getNewcoinsInfo',{params}).then((res) => {
            let resData = res.data.data;
            if(res.data.code == 1000){
              // this.$toast.center(res.data.message);
              setTimeout(()=>{
                this.$router.push('/login');
              },1000)
              return false
            }
            this.item2 = resData;
            this.kyMount = (parseInt(parseFloat(this.useBalance) * .98) / parseFloat(this.curPrice)).toFixed(4);
        }).catch(function(err){
            console.log(err)
        })
      },
      getMyNewcoins(){
        let params = {
          page: this.page
        }
        this.$ajax.get('/web/getMyNewcoins',{params}).then((res) => {
            let resData = res.data.data;
            if(res.data.code == 1000){
              // this.$toast.center(res.data.message);
              setTimeout(()=>{
                this.$router.push('/login');
              },1000)
              return false
            }
            if(resData.length > 0){
              this.list = this.list.concat(resData);
              this.curDataLength = resData.length;
            }else{
                this.curDataLength = resData.length;
            }
            if(this.list.length > 0){
                this.isNoData = false;
            }else{
                this.isNoData = true;
            }
          }).catch(function(err){
              console.log(err)
          })
      },
      getNewcoinsList(){
        let params = {
            page: this.page2
        }
        this.$ajax.get('/web/getNewcoinsList',{params}).then((res) => {
            let resData = res.data.data;
            if(resData.length > 0){
              this.item = resData[0];
              this.amount_rate = resData[0].amount_rate;
              this.endTimes = parseInt(resData[0].yxq_end);
              var currency = resData[0].currency;
              this.currency = currency.toLowerCase();
              this.initWebSocket();
              this.beginTimer();
              this.getWeiTuo();
              this.curDataLength2 = res.length;
              resData.forEach((item,index) => {
                $.ajax({
                  url: this.domain + "/web/icon?c=" + item.currency,
                  type: "GET",
                  data: {},
                  success: (resIcon)=> {
                    if(typeof resIcon === 'string')  resIcon = JSON.parse(resIcon);
                    item.icon = resIcon.data;
                  },error: function(res) {
                      console.log(res)
                  }
                })
              });
              this.currencyList = resData;
              this.isNoData2 = false;
            }else{
              this.curDataLength2 = resData.length;
              this.isNoData2 = true;
            }
        }).catch(function(err){
            console.log(err)
        })
      },
      buy(){
        let params = {
          price: this.item.start_price,
          amount: this.amount,
          price_type: 1,
          mark: 1,
          currency: this.item.currency,
          deal_type: 1,
        }
        if(!this.amount || this.amount <= 0){
          this.$toast.center(this.$t('xbsg.qsrsl'));
          return;
        }else if(parseFloat(this.amount) < parseFloat(this.item2.min_amount)){
          this.$toast.center(this.$t('tipsNew.zdsl') + ' ' + this.item2.min_amount);
          return;
        }
        if(this.count == 1){
            this.count = 0;
        }else{
            return false;
        }
        this.$ajax.post('/web/createOrder',params).then((res) => {
            let resData = res.data;
            if(resData.code == 1){
                this.count = 1;
                this.$toast.center(resData.message);
            }else if(resData.code == 1000){
                this.$toast.center(resData.message);
            }else{
              this.$toast.center(resData.message);
              setTimeout(()=>{
                this.count = 1;
                this.$router.push('/IEORecords?currency=' + this.item.currency)
              },1000)
            }
        }).catch(function(err){
            console.log(err)
        })
      },
      keyMoney(){//输入数量规则
        var amount =  $('.number').val();
        amount = amount.replace(/[^\d.]/g, "");  //仅保留数字和"."
        amount = amount.replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
        amount = amount.replace(".", "$#*").replace(/\./g,'').replace('$#*','.');//去除其他"."
        amount = amount.replace(/^(\d+)\.(\d\d\d\d).*$/, '$1.$2');;//限制只能输入两个小数
        if (amount.indexOf(".") < 0 && amount != "") { //首位是0的话去掉
            amount = parseFloat(amount)
        }
        $('.number').val(amount)
      },
      listenScroll(e) {  //监听滚动
        let ele = e.srcElement ? e.srcElement : e.target;
        if(ele.scrollTop > 200){
            this.isGoTOP = true
        }else{
            this.isGoTOP = false
        }
        if (ele.scrollTop + ele.offsetHeight >= ele.scrollHeight) { //监听滚动到div底部
          if(this.curDataLength > 0){
            this.page ++;
            this.getMyNewcoins();
          }
        }
      },
      goTop(){
        $('.cotainer').animate({scrollTop:'0px'},'slow');
      },
      beginTimer() { //这个计时器是每秒减去数组中指定字段的时间
        if(this.zlEndTimes < 0) return;
        this.timer = setInterval(() => {
          var curTimes = Date.parse(new Date())/1000;
          this.zlEndTimes = this.endTimes - curTimes;
          if(this.zlEndTimes > 0) {
            this.isEnd = false;
            this.zlEndTimes = this.zlEndTimes - 1;//我这里后台返回的是秒数，如果是日期需要自己转换一下
          }else{
            this.isEnd = true;
          }
        }, 1000);
      },
      timeChange2(countDown){
        var $that = this;
        if(countDown < 0) {
          this.isEnd = true;
          // this.$router.push('/index');
          clearInterval(setInterval(this.timeChange2(countDown), 1000)); //当无剩余时间了，就停止执行timeChange函数
        }
        //求天时分秒 leftDate是毫秒
        let leftSecond = $that.fillNumber(countDown % 60);
        let leftMinute = $that.fillNumber((countDown / 60) % 60);
        let leftHours = $that.fillNumber((countDown / (60 * 60)) % 24);
        let leftDay = $that.fillNumber(countDown / (60 * 60) / 24);
        if(leftDay > 0){
          var html = `${leftDay} ${leftHours}:${leftMinute}:${leftSecond}`
        }else{
          if(leftHours > 0){
            var html = `${leftHours}:${leftMinute}:${leftSecond}`
          }else{
            var html = `${leftMinute}:${leftSecond}`
          }
        }
        return html;
      },
      fillNumber(num) {
        let number = Math.floor(num); //向下取整
        return number > 9 ? number : "0" + number;
      },
    },
    watch: {
      curPrice: {
        handler:function (val,oldValue){
          if(parseFloat(val)){
            this.kyMount = (parseInt(parseFloat(this.useBalance) * .98) / parseFloat(this.curPrice)).toFixed(4);
          }else{

          }
        },
        deep: true,
        immediate: true
      },
    },
    components:{
        navBar,
    },
    beforeDestroy(){
      clearInterval(this.timer);
      this.timer = null;
      clearInterval(this.timer2);
      this.timer2 = null;
    },
    destroyed(){
      clearInterval(this.timer);
      this.timer = null;
      clearInterval(this.timer2);
      this.timer2 = null;
    }
}
</script>
<style scoped>
    .head{
        position: fixed;
        top: 0;
        width: 100%;
        height: 1.6rem;
        padding: 0 .44rem;
        color: #000;
        line-height: 1.6rem;
        background: #fff;
        box-sizing: border-box;
        text-align: center;
    }
    .head .back{
        position: absolute;
        left: .4rem;
        top: 50%;
        width: .4rem;
        margin-top: -.4rem;
    }
    .head .title{
        font-size: .56rem;
    }
    .head .text{
        font-size: .48rem;
    }
    .cotainer{
        position: absolute;
        top: 1.6rem;
        bottom: 0;
        width: 100%;
        margin-bottom: 2.3rem;
        background: #f9f9f9;
        overflow-y: scroll;
    }
    .ieo-wrap{
      margin: .38rem .38rem 0;
      padding: .5rem .3rem .6rem;
      background-color: #fff;
	    border-radius: 0.25rem;
    }
    .ieo-wrap .ieo-head{
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .ieo-wrap .ieo-head .icon1{
      width: .54rem;
    }
    .ieo-wrap .ieo-head .icon2{
      position: absolute;
      right: 0;
      width: .54rem;
    }
    .ieo-wrap .ieo-mid{
      display: flex;
      align-items: center;
    }
    .ieo-wrap .ieo-mid .img{
      width: .58rem;
      height: .58rem;
      margin: 0 .2rem;
    }
    .ieo-wrap .ieo-mid .text{
      color: #000;
      font-size: .56rem;
    }
    .ieo-wrap .ieo-item{
      display: flex;
      justify-content: space-around;
      align-items: stretch;
      margin-top: .1rem;
    }
    .ieo-wrap .ieo-item .item-lt,.ieo-wrap .ieo-item .item-rt{
      text-align: center;
    }
    .ieo-wrap .ieo-item .item-lt,.ieo-wrap .ieo-item .item-rt{
      padding-top: .2rem;
      width: 32%;
    }
    .ieo-wrap .ieo-item .img-box{
      position: relative;
      width: 2.7rem;
	    height: 2.7rem;
      /* margin: 0 .2rem; */
      background-color: #d0e5ff;
      border-radius: 50%;
      box-shadow: 0rem 0rem 0.38rem 0.19rem
        rgba(6, 0, 1, 0.15);
      border: solid 0.1rem #a8c3ff;
      text-align: center;
    }
    .ieo-wrap .ieo-item .img-box .img{
      position: absolute;
      left: 50%;
      top: 50%;
      width: 1.46rem;
      height: 1.46rem;
      transform: translate(-50%,-50%);
    }
    .ieo-wrap .time-box{
      height: 1.26rem;
      margin-top: .7rem;
      color: #000;
      font-size: .45rem;
      line-height: 1.26rem;
      background-color: #e5e6ed;
      border-radius: 0.15rem;
      text-align: center;
    }
    .ieo-wrap .time-box .time{
      /* padding-left: .5rem; */
      font-size: .45rem;
    }
    .ieo-wrap .ieo-item .t1{
      min-height: 1.1rem;
      color: #a9a9a9;
      font-size: .4rem;
      /* white-space: nowrap; */
    }
    .ieo-wrap .ieo-item .t2{
      margin-top: .7rem;
      color: #3f3f3f;
      font-size: .4rem;
    }
    .cotainer .ul-box{
      margin: .5rem .38rem;
    }
    .cotainer .ul-box .ul-li{
      position: relative;
      margin-bottom: .38rem;
      padding: .6rem .5rem .6rem .38rem;
      background: #fff;
      border-radius: 0.25rem;
      box-shadow: 0 0 0.38rem 0.19rem rgba(6, 0, 1, 0.15);
    }
    .cotainer .ul-box .title{
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: .1rem;
      color: #000;
      font-size: .4rem;
    }
    .cotainer .ul-box .title .t2.active{
      color: #588bf8;
    }
    .cotainer .ul-box .item-box{
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding-right: .5rem;
      background: transparent !important;
    }
    .cotainer .ul-box .item-box .item{
      width: 50%;
    }
    .cotainer .ul-box .t1{
      padding-top: .5rem;
      color: #8a8a8a;
      font-size: .34rem;
    }
    .cotainer .ul-box .t2{
      padding-top: .5rem;
      color: #000;
      font-size: .34rem;
    }
    .cotainer .ul-box .t2.money{
      color: #eee;
    }
    .cotainer .ul-box .arrow{
      position: absolute;
      right: .5rem;
      top: 50%;
      width: .25rem;
      transform: translateY(-50%);
    }
    .cotainer .ul-box .item-rt{
      text-align: right;
    }
    /* 左侧弹窗 */
    .alert-wrap{
      position: fixed;
      left: 0;
      top: 1.6rem;
      bottom: 0;
      z-index: 998;
      width: 100%;
      background: rgba(0,0,0,.5);
    }
    .alert-box{
      position: fixed;
      left: 0;
      top: 1.6rem;
      bottom: 0;
      z-index: 999;
      width: 5.5rem;
      padding-top: .3rem;
      background: #f4f4f4;
      overflow-y: scroll;
    }
    .alert-wrap .alert-box .alert-item{
      display: flex;
      align-items: center;
      margin-bottom: .1rem;
      padding: .5rem .48rem;
      background: #fff;
    }
    .alert-wrap .alert-box .alert-item .icon{
      width: .58rem;
      height: .58rem;
    }
    .alert-wrap .alert-box .alert-item .text{
      flex: 1;
      padding: 0 .3rem;
      color: #000;
      font-size: .56rem;
    }
    .alert-wrap .alert-box .alert-item .arrow{
      width: .22rem;
    }

    .alert-buy-wrap{
      position: fixed;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      z-index: 1000;
      background: rgba(0,0,0,.3);
    }
    .alert-buy-wrap .alert-buy-box{
      position: fixed;
      left: .32rem;
      right: .32rem;
      top: 50%;
      z-index: 1001;
      padding: 0 .32rem;
      background: #fff;
      border-radius: 0.3rem;
      transform: translateY(-50%);
    }
    .alert-buy-wrap .alert-head{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: .9rem 0 1rem;
      color: #4a4a4a;
      font-size: .48rem;
    }
    .alert-buy-wrap .alert-head .money{
      color: #23b757;
    }
    .alert-buy-wrap .alert-head .t2{
      color: #23b757;
      font-size: .56rem;
    }
    .alert-buy-wrap .type-box{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: .45rem 0 .76rem;
      color: #3f3f3f;
      font-size: .48rem;
      border-bottom: 1px solid #ececec;
    }
    .alert-buy-wrap .type-box .text2{
      font-size: .36rem;
    }
    .alert-buy-wrap .alert-tips{
      padding: .42rem 0 .3rem;
      color: #8a8a8a;
      font-size: .4rem;
    }
    .alert-buy-wrap .alert-tips2{
      color: #3f3f3f;
      font-size: .48rem;
    }
    .alert-buy-wrap .alert-text{
      color: #000;
      font-size: .4rem;
    }
    .alert-buy-wrap .bz-box{
      display: flex;
      align-items: center;
      flex-wrap: wrap;
    }
    .alert-buy-wrap .bz-box .bz{
      height: 0.96rem;
      margin: 0 .3rem .3rem 0;
      padding: 0 .48rem;
      color: #a9a9a9;
      font-size: .4rem;
      line-height: .96rem;
      background-color: #f7f7f7;
      border-radius: 0.48rem;
    }
    .alert-buy-wrap .bz-box .bz:nth-child(3n){
      margin-right: 0;
    }
    .alert-buy-wrap .bz-box .bz.active{
      color: #000;
      background: #fff;
    }
    .alert-buy-wrap .input-box{
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .alert-buy-wrap .input-box .input::placeholder{
      color: #a9a9a9;
      font-size: .48rem;
    }
    .alert-buy-wrap .input-box .input{
      width: 100%;
      height: 1.12rem;
      color: #000;
      font-size: .48rem;
      border-bottom: 1px solid #ececec;
    }
    .alert-buy-wrap .input-box .dw{
      color: #000;
      font-size: .48rem;
    }
    .alert-buy-wrap .btn-box{
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 1.2rem 0 .9rem;
    }
    .alert-buy-wrap .btn-box .btn{
      width: 4.4rem;
      height: 1.32rem;
      color: #000;
      font-size: .52rem;
      line-height: 1.32rem;
      background-color: #868bae;
      border-radius: 0.15rem;
      text-align: center;
    }
    .alert-buy-wrap .btn-box .btn-buy{
      background: #fff;
    }
    .buy-box{
      position: fixed;
      left: .38rem;
      right: .38rem;
      bottom: .8rem;
      height: 1.48rem;
      color: #fff;
      font-size: .56rem;
      line-height: 1.48rem;
      background-color: #000;
      border-radius: 0.15rem;
      text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/pages/IEOPurchase.vue